// @flow

import React from 'react';
import { RouterToUrlQuery } from 'react-url-query';
import { hot } from 'react-hot-loader';

import Auth from './contexts/Auth';
import UserInfo from './contexts/UserInfo';
import Intl from './providers/Intl';
import Helmet from './providers/Helmet';
import Router from './providers/Router';
import Apollo from './providers/Apollo';
import StyledTheme from './providers/StyledTheme';
import Layout from './components/Layout';
import Page from './components/Page';
import LocaleCode from './providers/LocaleCode';
import Buisness from './providers/Buisness';

import theme from './theme';
import routes, { NotFound } from './routes';
/* App */

const App = () => (
  <Auth>
    <Apollo>
      <UserInfo>
        <StyledTheme theme={theme}>
          <Router routes={routes} notFound={NotFound}>
            {renderPage => (
              <LocaleCode>
                {(localeCode: string) => {
                  window.CONFIG.LOCALE_CODE = localeCode;
                  return (
                    <Intl locale={localeCode}>
                      <Buisness>
                        <Helmet />
                        <Layout>
                          <RouterToUrlQuery>
                            <Page>{renderPage()}</Page>
                          </RouterToUrlQuery>
                        </Layout>
                      </Buisness>
                    </Intl>
                  );
                }}
              </LocaleCode>
            )}
          </Router>
        </StyledTheme>
      </UserInfo>
    </Apollo>
  </Auth>
);

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App.js